(function () {
  'use strict';

  var currency = new Intl.NumberFormat('es-PE', {
    style: 'currency',
    currency: 'PEN',
    minimumFractionDigits: 2
  });

  function escapeHtml(value) {
    var node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  function productImage(product) {
    var image = product.image || (product.featured_image && product.featured_image.url) || '';
    return image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy" width="64" height="64">' : '<span class="ge-predictive-search__image-placeholder"></span>';
  }

  function productPrice(product) {
    var value = product.price;
    if (value == null && product.price_min != null) value = product.price_min;
    value = Number(value);
    if (!Number.isFinite(value)) return '';
    if (value > 10000) value = value / 100;
    return currency.format(value);
  }

  function setup(search) {
    if (search.dataset.gePredictiveReady === 'true') return;
    var form = search.querySelector('[data-live-search-form]');
    var input = search.querySelector('[data-live-search-input]');
    if (!form || !input) return;

    search.dataset.gePredictiveReady = 'true';
    var panel = document.createElement('div');
    panel.className = 'ge-predictive-search';
    panel.hidden = true;
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Sugerencias de productos');
    form.appendChild(panel);

    var timer;
    var controller;

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function render(products, query) {
      var html = '';
      if (products.length) {
        html += '<div class="ge-predictive-search__heading">Productos sugeridos</div>';
        html += products.map(function (product) {
          return '<a class="ge-predictive-search__item" role="option" href="' + escapeHtml(product.url) + '">' +
            '<span class="ge-predictive-search__image">' + productImage(product) + '</span>' +
            '<span class="ge-predictive-search__copy"><strong>' + escapeHtml(product.title) + '</strong><span>' + escapeHtml(productPrice(product)) + '</span></span>' +
            '<span class="ge-predictive-search__arrow" aria-hidden="true">›</span></a>';
        }).join('');
      } else {
        html += '<p class="ge-predictive-search__empty">No encontramos productos con ese nombre.</p>';
      }
      html += '<a class="ge-predictive-search__all" href="/search?type=product&q=' + encodeURIComponent(query) + '">Ver todos los resultados para “' + escapeHtml(query) + '”</a>';
      panel.innerHTML = html;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function searchProducts(query) {
      if (controller) controller.abort();
      controller = new AbortController();
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('Search failed'); return response.json(); })
        .then(function (data) {
          var products = (((data || {}).resources || {}).results || {}).products || [];
          if (input.value.trim() === query) render(products, query);
        })
        .catch(function (error) { if (error.name !== 'AbortError') close(); });
    }

    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      var query = input.value.trim();
      if (query.length < 2) { close(); return; }
      panel.hidden = false;
      panel.innerHTML = '<div class="ge-predictive-search__loading">Buscando productos…</div>';
      timer = window.setTimeout(function () { searchProducts(query); }, 220);
    });
    input.addEventListener('keydown', function (event) { if (event.key === 'Escape') close(); });
    document.addEventListener('click', function (event) { if (!search.contains(event.target)) close(); });
  }

  function init() {
    document.querySelectorAll('[data-live-search]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
